<div class="graph-container">
	<svg id="js-graph-{{circuitNr}}{{#if readOnly}}-readonly{{/if}}" class="no-select"
		xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
		xmlns="http://www.w3.org/2000/svg" version="1.1"
		viewBox="-300 0 2000 2000"
		preserveAspectRatio="xMinYMax meet"
		>
		<defs>
			<marker id="arrow" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
				<path d="M0,0 L0,6 L9,3 z" fill="{{axisColor}}" />
			</marker>
			<pattern id="grid" width="0.06667" height="0.07692" >
				<line x1="0" y1="0" x2="0" y2="100" stroke="grey" stroke-width="3"/>
				<line x1="0" y1="0" x2="100" y2="0" stroke="grey" stroke-width="3"/>
			</pattern>
			<clipPath id="coordinate-system-flow-{{circuitNr}}{{#if readOnly}}-readonly{{/if}}">
				<rect x="100" y="100" width="1505" height="1305"/>
			</clipPath>
			<clipPath id="coordinate-system-backflow-{{circuitNr}}{{#if readOnly}}-readonly{{/if}}">
				<rect x="100" y="100" width="1505" height="1305"/>
			</clipPath>
		</defs>
		{{!-- grid --}}
		<rect id="js-grid-container" x="100" y="100" width="1500" height="1300" fill="url(#grid)" stroke="grey" stroke-width="1" />

		<g id="axis-labels" font-size="50" text-anchor="middle" fill="{{labelColor}}">
			{{!-- y-labels--}}
			<text x="100" y="1500">20 °C</text>
			<text x="600" y="1500">0 °C</text>
			<text x="1100" y="1500" >-20 °C</text>
			<text x="1600" y="1500" >-40 °C</text>

			{{!-- x-labels--}}
			<text x="40" y="1425" text-anchor="end" >20 °C</text>
			<text x="40" y="1125" text-anchor="end" >50 °C</text>
			<text x="40" y="625" text-anchor="end" >100 °C</text>
			<text x="40" y="125" text-anchor="end" >150 °C</text>
		</g>
		<g id="axis ticks" stroke="{{axisColor}}" stroke-width="3">
			{{!-- y-ticks--}}
			<line x1="100" y1="1400" x2="100" y2="1450"/>
			<line x1="600" y1="1400" x2="600" y2="1450"/>
			<line x1="1100" y1="1400" x2="1100" y2="1450"/>
			<line x1="1600" y1="1400" x2="1600" y2="1450"/>
			{{!-- x-ticks--}}
			<line x1="50" y1="1400" x2="100" y2="1400"/>
			<line x1="50" y1="1100" x2="100" y2="1100"/>
			<line x1="50" y1="600" x2="100" y2="600"/>
			<line x1="50" y1="100" x2="100" y2="100"/>
		</g>

		{{!-- x-axis --}}
		<line x1="100" y1="1400" x2="1650" y2="1400"
			stroke="{{axisColor}}" stroke-width="5"
			marker-end="url(#arrow)"/>
		<text x="1500" y="1550" fill="black" font-size="50" text-anchor="middle">{{TR "Außentemp."}}</text>

		{{!-- y-axis --}}
		<line x1="100" y1="1450" x2="100" y2="50"
			stroke="{{axisColor}}" stroke-width="5"
			marker-end="url(#arrow)"/>
		{{#unless readOnly}}
		<text x="50" y="50" fill="black" font-size="50" text-anchor="end" dominant-baseline="central">{{currentName}}</text>
		{{/unless}}
		{{!-- legend --}}
		{{!-- <rect x="100" y="1650" width="800" height="200" fill="lightgrey" stroke="none"/> --}}
		<line x1="-150" y1="1670" x2="-50" y2="1670" stroke="red" stroke-width="3" stroke-dasharray="{{plotData.dashstyle}}"/>
		<text x="-20" y="1670" fill="#393939" font-size="50" text-anchor="start" dominant-baseline="central">{{TR "Vorlauftemperatur Tag"}}</text>
		<line x1="-150" y1="1750" x2="-50" y2="1750" stroke="black" stroke-width="3" stroke-dasharray="{{plotData.dashstyle}}"/>
		<text x="-20" y="1750" fill="#393939" font-size="50" text-anchor="start" dominant-baseline="central">{{TR "Vorlauftemperatur Nacht"}}</text>
		<line x1="-150" y1="1830" x2="-50" y2="1830" stroke="blue" stroke-width="3" stroke-dasharray="{{plotData.dashstyle}}"/>
		<text x="-20" y="1830" fill="#393939" font-size="50" text-anchor="start" dominant-baseline="central">{{TR "Rücklauftemperatur"}}</text>
		{{#if noTemp}}
			<line x1="-150" y1="1910" x2="-50" y2="1910" stroke="{{noTemp.color}}" stroke-width="5"/>
			<text x="-20" y="1910" fill="#393939" font-size="50" text-anchor="start" dominant-baseline="central">{{TR "Akt. Vorlauftemperatur"}}, {{TR "Außentemperatur unbekannt!"}}</text>
		{{/if}}


		{{!-- no outdoor temperatur available? -> constant regulation! --}}
		{{#if noTemp}}
			<line class="js-no-temperatur" x1="100" y1="{{noTemp.y}}" x2="1600" y2="{{noTemp.y}}" stroke="{{noTemp.color}}" stroke-width="8"/>
			<text class="js-no-temperatur"  x="40" y="{{CALCULATE noTemp.y '+' 25}}"
				text-anchor="end" stroke="{{noTemp.color}}" fill="{{noTemp.color}}" font-size="50">{{noTemp.val}} °C</text>
		{{/if}}

		{{#unless readOnly}}
		{{!-- limits--}}
		<g id="js-limits" stroke="{{color}}" fill="{{color}}">
			<g id="js-max-limit" {{#unless readOnly}}class="clickable"{{/unless}}>
				<line id="js-max-line" x1="50" y1="{{limit.max}}" x2="1600" y2="{{limit.max}}"
					stroke-width="5" stroke-dasharray="10 10"/>
				<rect id="js-max-background" x="-200" y="{{limit.maxTextBackgroundPos}}" width="260" height="60" fill="white" stroke="none"></rect>
				<text id="js-max-text"
					x="40" y="{{limit.maxTextPos}}"
					font-size="50" text-anchor="end">
					max: {{limit.maxText}} °C
				</text>
			</g>

			<g id="js-min-limit" {{#unless readOnly}}class="clickable"{{/unless}}>
				<line id="js-min-line" x1="50" y1="{{limit.min}}" x2="1600" y2="{{limit.min}}"
					stroke-width="5" stroke-dasharray="10 10"/>
				<rect id="js-min-background" x="-200" y="{{limit.minTextBackgroundPos}}" width="260" height="60" fill="white" stroke="none"></rect>
				<text id="js-min-text"
					x="40" y="{{limit.minTextPos}}"
					font-size="50" text-anchor="end">
					min: {{limit.minText}} °C
				</text>
			</g>
		</g>

		{{#if flowTemp}}
		<g id="js-current-temp">
			<line x1="100" y1="{{flowTemp.y}}" x2="{{flowTemp.x}}" y2="{{flowTemp.y}}" stroke="darkgreen" stroke-width="3" stroke-dasharray="50 50"/>
			<rect x="-150" y="{{CALCULATE flowTemp.y '-' 50}}" width="200" height="60" fill="white" stroke="none"></rect>
			<text x="40" y="{{CALCULATE flowTemp.y '+' 25}}" text-anchor="end" fill="darkgreen" font-size="50">{{flowTemp.value}}</text>
			<line x1="{{temp.x}}" y1="50" x2="{{temp.x}}" y2="1450" stroke="darkgreen" stroke-width="3" stroke-dasharray="50 50"/>
		</g>
		{{/if}}
		{{/unless}}
		{{!-- current outdoor temperatur--}}
		{{#unless noTemp}}
		{{#unless readOnly}}
			<text x="{{temp.textPosX}}" y="40"
				fill="darkgreen"
				font-size="40"
				text-anchor="middle">{{TR "akt. Außentemperatur"}}: {{temp.text}} °C
			</text>
		{{/unless}}
		{{/unless}}

		{{> (lookup . 'graphTemplate') plotData=plotData}}

	</svg>
</div>
{{#unless readOnly}}
<div class="type-select-container">
	{{#each flowTypes}}
	{{#unless disabled}}
	<button id="{{id}}" class="select-{{@index}} btn-sm js-set-type btn btn-{{#if selected}}inverse{{else}}white{{/if}}">
		 {{name}}{{#if icon}} <i class="{{icon}}"></i>{{/if}}</button>
	{{/unless}}
	{{/each}}
</div>
{{/unless}}
{{> (lookup . 'configTemplate') config=config}}
{{#unless readOnly}}
<table class="limit-container config-table">
	<thead>
		<tr>
			<th colspan="3" class="table-heading">{{TR "Begrenzungen"}}</th>
		</tr>
		<tr colspan="3" class="blank-row"></tr>
	</thead>
	<tbody>
		<tr>
			<th>{{TR "Max"}}</th>
			<td>
				<input id="max-{{circuitNr}}{{#if readOnly}}-readonly{{/if}}" class="form-control input-sm js-limits text-right" type="number" value="{{limit.maxText}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon b-0"> °C </span>
			</td>
		</tr>
		<tr>
			<th>{{#if isBackFlow}}{{TR "Fußpunkt"}}{{else}}{{TR "Min"}}{{/if}}</th>
			<td>
				<input id="min-{{circuitNr}}{{#if readOnly}}-readonly{{/if}}" type="number" class="form-control input-sm js-limits text-right" value="{{limit.minText}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon b-0"> °C </span>
			</td>
		</tr>
	</tbody>
</table>
{{/unless}}
